import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IInstructionFeedbackActivityTemplate } from "@/interfaces/api/instruction-feedback-activity-template.interface.ts"
import type { IInstructionFeedbackActivity } from "@/interfaces/api/instruction-feedback-activity.interface.ts"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder.ts"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface.ts"
import type { AxiosResponse } from "axios"

export class InstructionFeedbackActivityTemplateRepository extends BaseRepository<IInstructionFeedbackActivityTemplate> {
  resourcePath = "planning/instruction-feedback-activity-templates"

  public async createInstructionFeedbackActivity(
    templateId: string,
    instructionFeedbackId: string,
    config: IRepositoryRequestConfig = {}
  ): Promise<AxiosResponse<IInstructionFeedbackActivity>> {
    return await new HTTPRequestBuilder(
      HTTPMethods.POST,
      `${this.getResourcePath(templateId, config)}create-instruction-feedback-activity/`
    )
      .setData({ instruction_feedback: instructionFeedbackId })
      .query(config.query)
      .setExpectedStatusCode(201)
      .setbeforeErrorHandlingCallback(config.beforeErrorHandlingCallback)
      .addStatusCodeHandlers(config.statusCodeHandlers)
      .build()
      .execute()
  }
}
